import React, { useState, useEffect } from 'react';
import { Col, Form, Row, Button } from 'react-bootstrap';
import '../Help.css';

import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import {
  AddCOIChatAsync,
  selectCOIChatList,
  selectUpdateDeclarationStatus
} from '../../../features/helpandassistance/DeclarationSlice';
import FileUpload from '../../../components/textField/FileUpload';

const reasonList: any = [
  {
    label: 'Not in line with the Company policies or applicable law',
    value: 'Not in line with the Company policies or applicable law'
  },
  {
    label: 'Not the ultimate approving authority',
    value: 'Not the ultimate approving authority'
  },
  {
    label: 'Previous record of undertaking unethical activities',
    value: 'Previous record of undertaking unethical activities'
  },
  {
    label: 'Additional details are required as the policy/ applicable law',
    value: 'Additional details are required as the policy/ applicable law'
  },
  { label: 'Other', value: 'Other' }
];

const ApproveRejectDeclaration = ({
  dataObj,
  type = '',
  statusId
}: {
  dataObj?: any;
  type?: string;
  statusId?: any;
}) => {
  const dispatch = useAppDispatch();

  const changeStatus = useAppSelector(selectUpdateDeclarationStatus);
  const chatList = useAppSelector(selectCOIChatList);

  const [modalShow, setModalShow] = useState(false);
  const [Remark, setRemark] = useState('');
  const [status, setStatus] = useState<any>('');
  const [IsAPI, setIsAPI] = useState(false);
  const [file1, setFile1] = useState('');
  const [reason, setReason] = useState('');
  const [disabled, setDisabled] = useState(false);

  const userDetails = localStorage.getItem('userDetails');
  const userDetailsList: any = userDetails;
  const userDetailsJson = JSON.parse(userDetailsList);

  useEffect(() => {
    if (IsAPI && chatList) {
      setIsAPI(false);
      handleClose();
    }
  }, [chatList]);

  const handleClose = () => {
    setRemark('');
    setModalShow(false);
    setStatus('');
    setFile1('');
    setReason('');
  };
  const handleShow = (val: any) => {
    setModalShow(true);
    setStatus(val);
  };

  const onSubmits = async (event: any) => {
    event.preventDefault();
    setIsAPI(true);

    let fileList = [];
    if (!!file1) {
      fileList.push(file1);
    }
    const chatData = {
      coiId: dataObj?.id,
      message: Remark,
      reason: reason,
      status: status == 4 ? 0 : status,
      fileName: fileList.join(',')
    };

    // console.log("==== send back api ====");
    await dispatch(AddCOIChatAsync(chatData));
    // }
  };
  return (
    <>
      {!modalShow &&
        (type === 'pending' ? (
          <Row>
            {
              <>
                <Col xs={6} sm='auto' className='ms-auto'>
                  <button
                    className='button'
                    onClick={(e: any) => handleShow(1)}
                    style={{
                      padding: '6px 20px',
                      fontFamily: 'Saira',
                      fontSize: '14px',
                      fontWeight: 500,
                      fontStretch: 'normal',
                      fontStyle: 'normal'
                    }}
                  >
                    {'Approve'}
                  </button>
                </Col>
                <Col xs={6} sm='auto' className=''>
                  <button
                    className='button'
                    onClick={(e: any) => handleShow(2)}
                    style={{
                      padding: '6px 20px',
                      fontFamily: 'Saira',
                      fontSize: '14px',
                      fontWeight: 500,
                      fontStretch: 'normal',
                      fontStyle: 'normal'
                    }}
                  >
                    {'Reject'}
                  </button>
                </Col>
                <Col xs={6} sm='auto' className='me-auto'>
                  <button
                    className='button'
                    onClick={(e: any) => handleShow(3)}
                    style={{
                      padding: '6px 20px',
                      fontFamily: 'Saira',
                      fontSize: '14px',
                      fontWeight: 500,
                      fontStretch: 'normal',
                      fontStyle: 'normal'
                    }}
                  >
                    {'Send Back'}
                  </button>
                </Col>
              </>
            }
          </Row>
        ) : (
          statusId == 3 && (
            <Row>
              {
                <>
                  {/* <Col xs={6} sm='auto' className='mx-auto mb-2'>
                    <button
                      className='button'
                      onClick={(e: any) => handleShow(4)}
                      style={{
                        padding: '6px 20px',
                        fontFamily: 'Saira',
                        fontSize: '14px',
                        fontWeight: 500,
                        fontStretch: 'normal',
                        fontStyle: 'normal',
                      }}
                    >
                      {'Reply'}
                    </button>
                  </Col> */}
                </>
              }
            </Row>
          )
        ))}
      {modalShow && (
        <Form onSubmit={onSubmits}>
          <Row style={{ padding: '24px', backgroundColor: '#e3e3e3' }}>
            {(status == 2 || status == 3) && (
              <Col xs={12} className='pb-3 pt-2'>
                <select
                  id='declare'
                  onChange={(e: any) => setReason(e.target.value)}
                  value={reason}
                  className='shadow-none d-inline-block'
                  style={{
                    backgroundColor: 'white',
                    border: 'solid 1px #e4e4e4',
                    borderRadius: '0px',
                    width: '100%',
                    fontFamily: 'Saira',
                    fontSize: '16px',
                    color: '#6d6e71'
                  }}
                  required
                >
                  <option value=''>Select Reason*</option>
                  {reasonList.length > 0 &&
                    reasonList.map((val: any) => (
                      <option value={val.value}>{val.label}</option>
                    ))}
                </select>
              </Col>
            )}
            {(status == 1 || reason === 'Other') && (
              <Col sm={12} xs={12}>
                <Form.Control
                  className='shadow-none'
                  style={styles.text1}
                  as='textarea'
                  rows={2}
                  placeholder='Remark *'
                  id='remark'
                  value={Remark}
                  onChange={(e: any) => setRemark(e.target.value)}
                  required
                  maxLength={1000}
                />
                <Row>
                  <Col xs='auto' className='ms-auto'>
                    {1000 - Remark?.length} remaining
                  </Col>
                </Row>
              </Col>
            )}
            <Col xs={12} sm={4} className='pb-3 pt-2'>
              <FileUpload
                setFile={setFile1}
                title='Attachment 1 (optional)'
                fileValue={file1}
                fileType='other'
                accept='.doc,.docx,.pdf,.jpg,.jpeg,.txt,.svg'
                isRequired={false}
                setDisabled={setDisabled}
              />
            </Col>
            <Col xs='auto' className='ms-auto mt-3'>
              {type === 'pending' ? (
                <Button
                  type='submit'
                  style={styles.button}
                  disabled={
                    (status == 1 && (!Remark || !Remark?.trim())) ||
                    ((status == 2 || status == 3) &&
                      (!reason ||
                        (reason === 'Other' &&
                          (!Remark || !Remark?.trim())))) ||
                    IsAPI ||
                    disabled
                  }
                >
                  {status == 3
                    ? 'Send Back'
                    : status == 1
                    ? 'Approve'
                    : 'Reject'}
                </Button>
              ) : (
                <></>
              )}
            </Col>
            <Col xs='auto' className='mt-3'>
              <Button style={styles.button} onClick={handleClose}>
                Cancel
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </>
  );
};

const styles: any = {
  text1: {
    fontFamily: 'Saira',
    fontSize: '16px',
    color: '#6d6e71',
    border: 'solid 1px #e4e4e4',
    borderRadius: '0px'
  },
  button: {
    padding: '13px 40px',
    fontFamily: 'Saira',
    fontSize: '12px',
    fontWeight: 400,
    fontStretch: 'normal',
    fontStyle: 'normal',
    borderRadius: '0',
    backgroundColor: '#e31837',
    letterSpacing: 'normal',
    border: '0px',
    color: '#fff'
  }
};

export default ApproveRejectDeclaration;
